import { useQuery } from "@tanstack/react-query";
import { userApi } from "@queries/User";
import queryKeys from "../../constants/queryKeys";

export default function useAccessibleOrganizations() {
  return useQuery({
    queryKey: [queryKeys.ACCESSIBLE_ORGANIZATIONS],
    queryFn: async () => userApi.getAccessibleOrganizations(),
    staleTime: 60 * 1000
  });
}
